import * as React from 'react'
import { useOutletContext, useParams } from 'react-router-dom'

import EmployeeReviewAnalytics from 'modules/reviews/components/Employees/Review/Analytics'
import { EmployeeRouteContextParams } from 'modules/reviews/lib/EmployeeRouteContextParams'

const ReviewAnalyticsPage = () => {
  const { id } = useParams()
  const { review } = useOutletContext<EmployeeRouteContextParams>()

  if (!review) return null

  return <EmployeeReviewAnalytics form={review} employeeId={Number(id)} />
}

export default ReviewAnalyticsPage
